function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsImport = function SvgSettingsImport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,22.4v9A1.56,1.56,0,0,1,31.48,33H18.56A1.56,1.56,0,0,1,17,31.44h0v-9a1.56,1.56,0,0,1,1.56-1.56H20.5v1.34H18.56a.18.18,0,0,0-.18.18v9a.18.18,0,0,0,.18.18H31.44a.18.18,0,0,0,.18-.18h0v-9a.18.18,0,0,0-.18-.18H29.5V20.84h1.94A1.56,1.56,0,0,1,33,22.4Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.08,26.11V17.89A.89.89,0,0,1,25,17h0a.89.89,0,0,1,.89.89h0v8.22A.89.89,0,0,1,25,27h0a.89.89,0,0,1-.92-.86h0Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.36,28.19l-3-3a.89.89,0,0,1,0-1.19h0a.89.89,0,0,1,1.26,0h0l3,3a.89.89,0,0,1,0,1.26h0a.91.91,0,0,1-1.26,0Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.38,26.93l3-3a.91.91,0,0,1,1.26,0h0a.89.89,0,0,1,0,1.26h0l-3,3a.91.91,0,0,1-1.26,0h0a.89.89,0,0,1,0-1.26Z",
    style: {
      fill: "#666"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsImport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-import.61347b19.svg";
export { ForwardRef as ReactComponent };